import script from "./WhiteButton.vue?vue&type=script&setup=true&lang=js"
export * from "./WhiteButton.vue?vue&type=script&setup=true&lang=js"

import "./WhiteButton.vue?vue&type=style&index=0&id=e071d588&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e071d588"]])

export default __exports__